export default __webpack_public_path__ + "static/media/ReversalCharges.f76f4230.svg";